import React from "react";
import Usermanagement from "./components/Usermanagement";
 
const App = () => {
  return <Usermanagement />;
};
 
export default App;